/* The Skin Read: "Send my result to Clara" consultation box on the self-check result.
   Add-on to ce-skin-read-v2.js. Optional; the result never depends on it.
   Posts the result through Shopify's contact form, so it arrives as an ordinary store email
   (reply goes to the visitor). No customer record, no mailing list. If Shopify refuses the post
   (for example its hCaptcha check is on for contact forms), it opens an email draft to Clara. */
(function(){
"use strict";
var ROOT = document.getElementById("ce-sr2");
var API = window.__ceSR2;
if (!ROOT || !API) return;
var S = API.S, $view = document.getElementById("ce-sr2-view");
var TO = "clara@completeelixir.com";

var TX = {
 en:{
  eb:"Would you like a consultation?",
  h:"Send your result to Clara",
  p:"Clara Song, Ph.D., our founder and formulator, reads every result that is sent to her and replies by email with what she would do for your skin. This is optional and free.",
  name:"Your name (optional)", email:"Your email, so Clara can reply", note:"Anything you would like her to know (optional)",
  open:"Request a consultation", btn:"Send my result to Clara", sending:"Sending…",
  fine:"Your result and these details go only to Complete Elixir for this consultation. You will not be added to a mailing list.",
  bad:"Please check the email address.",
  done:"Sent. Clara will reply to",
  doneSub:"If you do not see a reply, please check your spam folder.",
  err:"That did not go through. You can also email clara@completeelixir.com.",
  draft:"Your email app should open with your result. Press send there to reach Clara."
 },
 ko:{
  eb:"상담을 원하시나요?",
  h:"결과를 Clara에게 보내기",
  p:"창업자이자 포뮬레이터인 Clara Song, Ph.D.가 보내 주신 결과를 직접 읽고, 피부에 맞는 방법을 이메일로 답해 드립니다. 선택 사항이며 무료입니다.",
  name:"이름 (선택)", email:"답장 받을 이메일", note:"전하고 싶은 내용 (선택)",
  open:"상담 요청하기", btn:"결과를 Clara에게 보내기", sending:"보내는 중…",
  fine:"결과와 입력하신 정보는 이 상담을 위해서만 Complete Elixir에 전달됩니다. 메일링 리스트에 추가되지 않습니다.",
  bad:"이메일 주소를 확인해 주세요.",
  done:"보냈습니다. Clara가 이 주소로 답장드립니다:",
  doneSub:"답장이 보이지 않으면 스팸함을 확인해 주세요.",
  err:"전송되지 않았습니다. clara@completeelixir.com 으로 직접 보내셔도 됩니다.",
  draft:"메일 앱이 결과와 함께 열립니다. 그 화면에서 보내기를 눌러 주세요."
 },
 fr:{
  eb:"Vous aimeriez une consultation?",
  h:"Envoyez votre résultat à Clara",
  p:"Clara Song, Ph. D., notre fondatrice et formulatrice, lit chaque résultat qu’on lui envoie et répond par courriel avec ce qu’elle ferait pour votre peau. C’est facultatif et gratuit.",
  name:"Votre nom (facultatif)", email:"Votre courriel, pour que Clara puisse répondre", note:"Ce que vous aimeriez lui dire (facultatif)",
  open:"Demander une consultation", btn:"Envoyer mon résultat à Clara", sending:"Envoi…",
  fine:"Votre résultat et ces renseignements sont transmis uniquement à Complete Elixir pour cette consultation. Vous ne serez pas ajouté à une liste d’envoi.",
  bad:"Veuillez vérifier l’adresse courriel.",
  done:"Envoyé. Clara répondra à",
  doneSub:"Si vous ne voyez pas de réponse, vérifiez vos courriels indésirables.",
  err:"L’envoi n’a pas fonctionné. Vous pouvez aussi écrire à clara@completeelixir.com.",
  draft:"Votre application de courriel devrait s’ouvrir avec votre résultat. Appuyez sur Envoyer pour joindre Clara."
 }
};
function T(k){ var d=TX[S.lang]||TX.en; return d[k]!==undefined ? d[k] : TX.en[k]; }
function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c];}); }
function en(o){ return o ? (o.en!==undefined ? o.en : "") : ""; }

var C = { open:false, state:"", name:"", email:"", note:"" };   /* survives language switches and re-renders */

/* plain English summary for Clara: pattern, signals, what the page told them, and every answer */
function report(){
 var R=API.score(), hold=API.route(R), P=API.PAT[hold[0]].en, out=[];
 out.push("The Skin Read "+S.code+" · "+new Date().toISOString().slice(0,10)+" · page language: "+S.lang);
 out.push("From: "+(C.name||"(no name)")+" <"+C.email+">");
 if (C.note) out.push("", "Their note:", C.note);
 out.push("", "Pattern: "+P.name+(hold[1]?"  (also shows: "+API.PAT[hold[1]].en.name+")":""), P.line||"");
 if (R.flags.length) out.push("", "SEE A DOCTOR FIRST flagged: "+R.flags.join(", "));
 out.push("", "Signals:");
 Object.keys(API.AX).filter(function(k){ return R.sc[k]>0; }).sort(function(a,b){ return R.sc[b]-R.sc[a]; })
  .forEach(function(k){ out.push("  "+en(API.AX[k])[0]+": "+R.sc[k]); });
 out.push("", "Stop: "+(P.stop||[]).join("; "), "Start: "+(P.start||[]).join("; "));
 out.push("", "Routine shown:");
 API.routine(hold,R).forEach(function(x){ out.push("  "+en(x.role)+": "+x.p.name+" ("+en(API.WHEN[x.when])+")"); });
 out.push("", "Answers:");
 API.plan().forEach(function(id){
  var q=API.Q.filter(function(z){ return z.id===id; })[0], v=S.A[id]; if (!q || v===undefined) return;
  var picked=[].concat(v).map(function(val){ var o=q.o.filter(function(z){ return z[0]===val; })[0]; return o?o[1]:val; });
  out.push("  "+(q.en||id)+" → "+(picked.join("; ")||"(none)"));
 });
 return { text:out.join("\n"), pattern:P.name, secondary:hold[1]?API.PAT[hold[1]].en.name:"", refer:R.flags.join("; ") };
}

function boxHTML(){
 var h='<div class="src-in">'+'<p class="src-eb">'+esc(T("eb"))+'</p><h3>'+esc(T("h"))+'</h3>';
 if (C.state==="done") return h+'<p class="src-p">'+esc(T("done"))+' <b>'+esc(C.email)+'</b></p><p class="src-fine">'+esc(T("doneSub"))+'</p></div>';
 if (C.state==="draft") return h+'<p class="src-p">'+esc(T("draft"))+'</p></div>';
 /* closed until the visitor asks: one button, then the form */
 if (!C.open) return h+'<p class="src-p">'+esc(T("p"))+'</p><button class="cta" type="button" id="ce-src-open">'+esc(T("open"))+'</button></div>';
 var busy=C.state==="sending";
 return h+'<p class="src-p">'+esc(T("p"))+'</p>'+
  '<form id="ce-src" novalidate>'+
  '<input id="ce-src-name" autocomplete="name" placeholder="'+esc(T("name"))+'" aria-label="'+esc(T("name"))+'" value="'+esc(C.name)+'">'+
  '<input id="ce-src-email" type="email" autocomplete="email" inputmode="email" required placeholder="'+esc(T("email"))+'" aria-label="'+esc(T("email"))+'" value="'+esc(C.email)+'">'+
  '<textarea id="ce-src-note" rows="3" placeholder="'+esc(T("note"))+'" aria-label="'+esc(T("note"))+'">'+esc(C.note)+'</textarea>'+
  '<input id="ce-src-web" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" class="src-hp">'+
  '<p class="src-err" id="ce-src-err" role="alert"></p>'+
  '<button class="cta" type="submit"'+(busy?" disabled":"")+'>'+esc(busy?T("sending"):T("btn"))+'</button>'+
  '<p class="src-fine">'+esc(T("fine"))+'</p></form></div>';
}

function inject(){
 if (S.mode==="pro") return;                    /* consultation mode already has an esthetician in the room */
 var res=$view.querySelector(".res"); if (!res || res.querySelector(".src")) return;
 var wrap=document.createElement("div"); wrap.className="sec src"; wrap.innerHTML=boxHTML();
 res.insertBefore(wrap, res.querySelector(".code") || null);
 wire(wrap);
}
function repaint(){ var w=$view.querySelector(".src"); if (!w) return; w.innerHTML=boxHTML(); wire(w); }

function wire(w){
 var op=w.querySelector("#ce-src-open");
 if (op) op.onclick=function(){ C.open=true; repaint(); var e=$view.querySelector("#ce-src-email"); if (e) e.focus(); };
 var f=w.querySelector("#ce-src"); if (!f) return;
 var nm=f.querySelector("#ce-src-name"), em=f.querySelector("#ce-src-email"), nt=f.querySelector("#ce-src-note");
 nm.oninput=function(){ C.name=nm.value.trim(); };
 em.oninput=function(){ C.email=em.value.trim(); };
 nt.oninput=function(){ C.note=nt.value.trim(); };
 f.onsubmit=function(e){
  e.preventDefault();
  C.name=nm.value.trim(); C.email=em.value.trim(); C.note=nt.value.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(C.email)){ f.querySelector("#ce-src-err").textContent=T("bad"); em.focus(); return; }
  send(f.querySelector("#ce-src-web").value);
 };
}

function draft(r){                                /* fallback: the visitor's own mail app, addressed to Clara */
 location.href="mailto:"+TO+"?subject="+encodeURIComponent("Skin Read consultation · "+r.pattern+" · "+S.code)+
  "&body="+encodeURIComponent(r.text.slice(0,1800));
 C.state="draft"; repaint();
}
function send(hp){
 if (hp){ C.state="done"; repaint(); return; }    /* honeypot filled: a bot, drop it quietly */
 var r=report(), d=new FormData();
 d.append("form_type","contact"); d.append("utf8","✓");
 d.append("contact[name]",C.name); d.append("contact[email]",C.email);
 d.append("contact[Skin Read]",S.code+" · "+r.pattern+(r.refer?" · see a doctor first":""));
 d.append("contact[body]",r.text);
 C.state="sending"; repaint();
 /* Shopify answers a good post by redirecting with ?contact_posted=true */
 fetch("/contact",{ method:"POST", body:d, credentials:"same-origin" })
  .then(function(res){ if (/contact_posted=true/.test(res.url)){ C.state="done"; repaint(); } else draft(r); })
  .catch(function(){ draft(r); });
}

new MutationObserver(inject).observe($view, { childList:true });
inject();
})();
